import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';
import {fetchTasksByOrder} from './techniciansAssignment';

export const fetchOrderAndTasksStatus = (params = {}) => apiActionCreator({
  'endpoint': `/accessories/status${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_ORDER_AND_TASK_STATUS,
    ActionTypes.FETCHED_ORDER_AND_TASK_STATUS,
    [
      ActionTypes.FETCHED_ORDER_AND_TASK_STATUS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchPendingAccessoriesOrders = () => apiActionCreator({
  'endpoint': '/accessories/pending-orders',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PENDING_ACCESSORIES_ORDERS,
    ActionTypes.FETCHED_PENDING_ACCESSORIES_ORDERS,
    [
      ActionTypes.FETCHED_PENDING_ACCESSORIES_ORDERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchPendingAccessoriesOrdersByTechnician = (technicianID, params = {}) => apiActionCreator({
  'endpoint': `/accessories/pending-orders/technician/${technicianID}${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PENDING_ORDERS_LIST_BY_TECHNICIAN,
    ActionTypes.FETCHED_PENDING_ORDERS_LIST_BY_TECHNICIAN,
    [
      ActionTypes.FETCHED_PENDING_ORDERS_LIST_BY_TECHNICIAN_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchPdsClosedOrdersByTechnician = (technicianID, params = {}) => apiActionCreator({
  'endpoint': `/accessories/pending-orders/technician/${technicianID}/closed${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_CLOSED_PENDING_ORDERS_LIST_BY_TECHNICIAN,
    ActionTypes.FETCHED_CLOSED_PENDING_ORDERS_LIST_BY_TECHNICIAN,
    [
      ActionTypes.FETCHED_CLOSED_PENDING_ORDERS_LIST_BY_TECHNICIAN_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const addOrderTaskProgress = (order, task, data = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/accessories/orders/${order}/tasks/${task}/progress`,
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_ORDER_TASK_PROGRESS,
        [
          () => {
            dispatch(fetchTasksByOrder(order));
            const params = {
              'order': '',
              'type': data.orderType,
            };
            dispatch(fetchPendingAccessoriesOrdersByTechnician(data.technician, params));
            return {'type': ActionTypes.ADDED_ORDER_TASK_PROGRESS};
          },
        ],
        [
          ActionTypes.ADDED_ORDER_TASK_PROGRESS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      data,
    }),
  );
};
